import { render, staticRenderFns } from "./OperaGoodsSkuWindow.vue?vue&type=template&id=07cf7e7f&"
import script from "./OperaGoodsSkuWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsSkuWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports